import React from 'react';
import { Stack, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FlairIcon from '../../../../../../../../atomic/atoms/FlairIcon';
import { EmployeePosition } from './types';
import { SearchDropdown } from './SearchDropdown';

export const ControlsPanel: React.FC<{
  searchQuery: string;
  onSearchChange: (query: string) => void;
  displayStaffedPositions: boolean;
  onDisplayStaffedChange: (value: boolean) => void;
  showFullHierarchy: boolean;
  onShowFullHierarchyChange: (value: boolean) => void;
  searchPositions: EmployeePosition[];
  selectedPositionId: string;
  onPositionSelect: (positionId: string) => void;
  showSearchResults: boolean;
  onSearchFocus: () => void;
  onSearchClose: () => void;
  searchContainerRef: React.RefObject<HTMLDivElement>;
  t: (key: string, options?: { defaultValue?: string }) => string;
}> = ({
  searchQuery,
  onSearchChange,
  displayStaffedPositions,
  onDisplayStaffedChange,
  showFullHierarchy,
  onShowFullHierarchyChange,
  searchPositions,
  selectedPositionId,
  onPositionSelect,
  showSearchResults,
  onSearchFocus,
  onSearchClose,
  searchContainerRef,
  t,
}) => {
  return (
    <Stack gap={3}>
      <div className="position-relative" ref={searchContainerRef}>
        <div className="input-group">
          <span className="input-group-text">
            <FlairIcon icon="search-filled" size="sm" className="text-muted" />
          </span>
          <Form.Control
            type="text"
            placeholder={t('searchPlaceholder')}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={onSearchFocus}
          />
        </div>

        {searchQuery && showSearchResults && (
          <SearchDropdown
            searchPositions={searchPositions}
            selectedPositionId={selectedPositionId}
            onPositionSelect={(positionId) => {
              onPositionSelect(positionId);
              onSearchChange('');
              onSearchClose();
            }}
            onClose={onSearchClose}
            t={t}
          />
        )}
      </div>

      <div className="d-flex flex-column gap-2">
        <Form.Check
          type="switch"
          id="display-staffed"
          label={t('displayStaffed')}
          checked={displayStaffedPositions}
          onChange={(e) => onDisplayStaffedChange(e.target.checked)}
          className="small"
        />
        <div className="d-flex align-items-center">
          <Form.Check
            type="switch"
            id="show-full-hierarchy"
            label={t('showFullHierarchy')}
            checked={showFullHierarchy}
            onChange={(e) => onShowFullHierarchyChange(e.target.checked)}
            className="small"
          />
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="show-full-hierarchy-tooltip">
                {t('showFullHierarchyTooltip')}
              </Tooltip>
            }>
            <span className="ms-2">
              <FlairIcon
                icon="information-circle-outline"
                size="sm"
                className="text-muted"
                role="button"
              />
            </span>
          </OverlayTrigger>
        </div>
      </div>
    </Stack>
  );
};
